import React, {Component} from 'react';
import '../../style.css';
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import {
    Button,
    Card,
    Form,
    Input,
    message,
    Modal,
    PageHeader,
    Space,
    Table, Tag, Tooltip, Typography,
} from "antd";
import {DeleteOutlined, EditOutlined } from "@ant-design/icons";
import FileViewer from 'react-file-viewer';
const { Column } = Table;
const { Paragraph } = Typography;
class RDEquipment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            equipmentData:[],
            edit_visible:false,//编辑弹窗状态
            add_visible:false,//添加设备弹窗状态
            delete_visible:false,//删除弹窗状态
            deleteId: 0,//待删除设备Id
            editId: 0,//待修改设备Id
            code:'',
            name:'',
            unit:'',
            quantity:"",
            newCode:'',
            newName:"",
            newUnit:"",
            newQuantity:"",
            loading: false,
            fileStream:'',
            preview_visible:false,
            fileStream_upload:'',
            fileField:[],
            upload_visible:false,
            uploadFile_visible:false,
            checkStatus:false,
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.addEquipment = this.addEquipment.bind(this);
        this.updateEquipment = this.updateEquipment.bind(this);
        this.deleteEquipment = this.deleteEquipment.bind(this);
        this.codeChange = this.codeChange.bind(this);
        this.nameChange = this.nameChange.bind(this);
        this.unitChange = this.unitChange.bind(this);
        this.quantityChange = this.quantityChange.bind(this);
        this.codeChangeNew = this.codeChangeNew.bind(this);
        this.nameChangeNew = this.nameChangeNew.bind(this);
        this.unitChangeNew = this.unitChangeNew.bind(this);
        this.quantityChangeNew = this.quantityChangeNew.bind(this);
        this.hideModalTwo = this.hideModalTwo.bind(this);
    }
    componentDidMount() {
        this.setState(()=>({
            loading:true
        }))
        //获取设备列表
        fetchPost(global.constants.getRDEquipmentT,{companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            equipmentData:res.data,
                            loading:false
                        }))
                    }
                    else{
                        this.setState(()=>({
                            loading:false
                        }))
                        message.info("该公司还没有录入研发设备，请先添加！").then();
                    }
                }
            )
    }
    handleDelete= (e) =>{
        //确定删除弹窗
        const value = e.id;
        this.setState(()=>({
            delete_visible:true,
            deleteId:value,
        }))
    }
    deleteEquipment(){
        fetchPost(global.constants.deleteRDEquipment,{id:this.state.deleteId})
            .then(
                res => {
                    if(res.code === 200){
                        message.success('删除研发设备成功').then();
                        this.setState(()=>({
                            delete_visible:false
                        }))
                        fetchPost(global.constants.getRDEquipmentT,{companyId:this.state.companyId})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            equipmentData:res.data,
                                        }))
                                    }
                                    else{
                                        this.setState(()=>({
                                            equipmentData:[],
                                        }))
                                    }
                                }
                            )//更新后重新获取
                    }
                    else{
                        message.error(res.msg).then()
                    }
                }
            )
    }
    hideModal(){
        this.setState({
            add_visible:false,
            edit_visible:false,
            delete_visible:false,
            preview_visible:false,
            upload_visible:false,
        });
    }
    handleAdd(){
        //打开添加设备弹窗
        this.setState(()=>({
            add_visible:true,
            code:'',
            name:'',
            unit:'',
            quantity:"",
        }))
    };
    addEquipment(){
        if(this.state.name === ''||this.state.code === ''||this.state.unit=== ''||
            this.state.quantity === ''){
            message.info("请检查设备信息是否填写完整").then()
        }else{
            fetchPost(global.constants.addRDEquipment, {
                companyId:this.state.companyId,
                code:this.state.code,
                name:this.state.name,
                unit:this.state.unit,
                quantity:this.state.quantity,
            })
                .then(
                    res => {
                        if (res.code === 200) {
                            message.success('添加设备成功').then();
                            this.setState(() => ({
                                add_visible: false
                            }))
                            fetchPost(global.constants.getRDEquipmentT, {companyId:this.state.companyId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                equipmentData: res.data,
                                            }))
                                        }
                                    }
                                )//更新后重新获取
                        } else {
                            if (res.code === -1) {
                                message.error("插入失败，该设备已存在！").then()
                            }
                            if (res.code === -2) {
                                // console.log("插入失败，数据库异常！")
                            }
                        }
                    }
                )
        }
    }
    handleEdit= (e) =>{
        //打开编辑弹窗
        const value = e.id;
        let params = {
            id:e.id,
            code:e.code,
            name:e.name,
            unit:e.unit,
            quantity:e.quantity,
        }
        this.setState(()=>({
            editId:value,
        }))
        fetchPost(global.constants.updateRDEquipment,params)
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            newCode:res.data.code,
                            newName: res.data.name,
                            newUnit:res.data.unit,
                            newQuantity:res.data.quantity,
                            edit_visible:true,
                        }))
                    }
                }
            )
    }
    updateEquipment(){
        let params = {
            id:this.state.editId,
            code:this.state.newCode,
            name:this.state.newName,
            unit:this.state.newUnit,
            quantity:this.state.newQuantity,
        }
        fetchPost(global.constants.updateRDEquipment, params)
            .then(
                res => {
                    if(res.code === 200){
                        message.success("修改成功！").then();
                        this.setState(()=>({
                            edit_visible:false
                        }))
                        fetchPost(global.constants.getRDEquipmentT,{companyId:this.state.companyId})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            equipmentData:res.data,
                                        }))
                                    }
                                }
                            )//更新后重新获取
                    }
                    else{
                        message.error("修改失败").then();
                    }

                }
            )
    }
    handleExportClick(){
        fetchPost(global.constants.exportRDEquipmentT, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-24研发设备明细表.doc',
            fileName: '研发设备明细表.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    this.setState(()=>({
                        fileStream:res
                    }))
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-24研发设备明细表.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-24研发设备明细表.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/研发设备明细表.pdf',
                            fileName: '研发设备明细表.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadClick(e){
        this.setState(()=>({
            upload_visible:true,
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'研发设备明细表',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200){
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'研发设备明细表',
                            url: '',
                            fileName: ''
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream_upload:blobUrl,
                                                checkStatus:true
                                            }))
                                        })
                                }
                            )
                    }
                    else{
                        this.setState(()=>({
                            fileStream_upload:'',
                            checkStatus:false,
                        }))
                    }
                })
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
        }))
    }
    uploadFile(){
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',0);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark','研发设备明细表');
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                            let params = {
                                companyId:this.state.companyId,
                                projectId:0,
                                productId:0,
                                patentId:0,
                                otherId:0,
                                remark:'研发设备明细表',
                                url: '',
                                fileName: ''
                            }
                            fetchPostFile(global.constants.previewFile,params)
                                .then(
                                    res=>{
                                        res.blob().then(
                                            blob=> {
                                                let blobUrl = window.URL.createObjectURL(blob);
                                                this.setState(()=>({
                                                    fileStream_upload:blobUrl,
                                                    uploadFile_visible:false,
                                                    checkStatus:true,
                                                }))
                                            })
                                    }
                                )
                        }
                    })
        }
    }
    deleteUpload(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'研发设备明细表',
            url: '',
        }
        fetchPost(global.constants.deleteFile,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        this.setState(()=>({
                            checkStatus:false,
                        }))
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="研发设备"
                        subTitle='可编辑生成或上传，只允许上传50M以内的pdf格式的文件'
                        extra={[
                            <Button type="primary"  onClick={this.handleUploadClick.bind(this)}>上传</Button>,
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Tooltip title="预览生成的文件">
                                <Button
                                    type="primary"
                                    onClick={this.handlePreviewClick.bind(this)}
                                >预览</Button>
                            </Tooltip>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <div>
                    <Paragraph>
                        <pre>注：若两种方式的文件均存在，文件合成时系统自动选取上传的文件。</pre>
                    </Paragraph>
                </div>
                <Space direction="vertical" className="content-style" >
                    <div className = "content-header-area">
                            <span className="content-header">
                            研发设备明细表
                            </span>
                    </div>
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.equipmentData} loading={this.state.loading} onHeaderRow={()=>{return{className:"list-column-style"}}}>
                            <Column
                                align="center"
                                title={<p className="list-column-style">序号</p>}
                                width="80"
                                render={
                                    (text,record,index)=>(`${index+1}`)} />
                            <Column
                                align="center"
                                title={<p className="list-column-style">设备编号</p>}
                                dataIndex="code"
                                key="code" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">设备名称</p>}
                                dataIndex="name"
                                key="name" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">计量单位</p>}
                                dataIndex="unit"
                                key="unit" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">数量</p>}
                                dataIndex="quantity"
                                key="quantity" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<EditOutlined />}
                                            onClick={this.handleEdit.bind(this,record)}
                                        >编辑</Button>
                                        <Button
                                            type="primary"
                                            icon={<DeleteOutlined />}
                                            onClick={this.handleDelete.bind(this,record)}
                                        >删除</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                    <div className="upload-button">
                        <Button
                            type="primary"
                            onClick={this.handleAdd}
                        >
                            添加研发设备
                        </Button>
                    </div>
                </Space>
                <Modal
                    visible={this.state.edit_visible}
                    title={'修改设备信息'}
                    onOk={this.updateEquipment}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.updateEquipment}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="设备编号" name="newCode">
                            <Input
                                defaultValue={this.state.newCode}
                                onChange={(e) => this.codeChangeNew(e.target.value)}/></Form.Item>
                        <Form.Item label="设备名称" name="newName">
                            <Input defaultValue={this.state.newName}
                                   onChange={(e) => this.nameChangeNew(e.target.value)}/>
                        </Form.Item>
                        <Form.Item label="计量单位" name="newUnit">
                            <Input defaultValue={this.state.newUnit}
                                   onChange={(e) => this.unitChangeNew(e.target.value)}/>
                        </Form.Item>
                        <Form.Item label="数量" name="newQuantity">
                            <Input defaultValue={this.state.newQuantity}
                                   onChange={(e) => this.quantityChangeNew(e.target.value)}/>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.add_visible}
                    title={'添加设备'}
                    onOk={this.addEquipment}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.addEquipment}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="设备编号" name="code" rules={[{ required: true, message: '请输入设备编号!' }]}>
                            <Input
                                defaultValue={this.state.code}
                                onChange={(e) => this.codeChange(e.target.value)}/></Form.Item>
                        <Form.Item label="设备名称" name="name" rules={[{ required: true, message: '请输入设备名称!' }]}>
                            <Input defaultValue={this.state.name}
                                   onChange={(e) => this.nameChange(e.target.value)}/>
                        </Form.Item>
                        <Form.Item label="计量单位" name="unit" rules={[{ required: true, message: '请输入计量单位!' }]}>
                            <Input defaultValue={this.state.unit}
                                   onChange={(e) => this.unitChange(e.target.value)}/>
                        </Form.Item>
                        <Form.Item label="数量" name="quantity" rules={[{ required: true, message: '请输入数量!' }]}>
                            <Input defaultValue={this.state.quantity}
                                   onChange={(e) => this.quantityChange(e.target.value)}/>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.delete_visible}
                    title={'温馨提示'}
                    onOk={this.deleteEquipment}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.deleteEquipment}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定删除该研发设备吗？</div>
                </Modal>
                <Modal
                    visible={this.state.preview_visible}
                    title={'预览'}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'50%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                            下载
                        </Button>,
                    ]}
                >
                    <FileViewer fileType='pdf'
                                filePath={this.state.fileStream}
                                onError={this.onError}
                    />
                </Modal>
                <Modal
                    visible={this.state.upload_visible}
                    title={'上传附件'}
                    onCancel={this.hideModal.bind(this)}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal.bind(this)}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                            完成
                        </Button>,
                    ]}
                >
                    <div>
                        该公司的研发设备明细表
                        {this.state.checkStatus === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                        <Form style={{marginTop:'20px'}}>
                            <Form.Item
                                name='file'
                                method="post"
                                enctype="multipart/form-data"
                            >
                                <input
                                    type="file"
                                    name='file'
                                    onChange={this.fileInput.bind(this)}
                                />
                            </Form.Item>
                            <Form.Item name="preview_paper">
                                {
                                    this.state.checkStatus === true &&
                                    <div>
                                        <Button type={"primary"} onClick={this.deleteUpload.bind(this)}>删除</Button>
                                        <FileViewer fileType='pdf'
                                                    filePath={this.state.fileStream_upload}
                                                    onError={this.onError}
                                        />
                                    </div>
                                }
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.uploadFile_visible}
                    title={'上传'}
                    onCancel={this.hideModalTwo.bind(this)}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.uploadFile.bind(this)}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定上传该研发设备明细表吗？</div>
                </Modal>
            </div>
        )
    }
    codeChange(e){
        this.setState({
            code:e
        })
    }
    nameChange(e){
        this.setState({
            name:e
        })
    }
    unitChange(e){
        this.setState({
            unit:e
        })
    }
    quantityChange(e){
        this.setState({
            quantity:e
        })
    }
    codeChangeNew(e){
        this.setState({
            newCode:e
        })
    }
    nameChangeNew(e){
        this.setState({
            newName:e
        })
    }
    unitChangeNew(e){
        this.setState({
            newUnit:e
        })
    }
    quantityChangeNew(e){
        this.setState({
            newQuantity:e
        })
    }

}

export default RDEquipment;